import React from 'react'
import PropTypes from 'prop-types'

import { Button, Icon } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const DeliveryModal = ({ onClose = () => {}, handleExit = () => {} }) => {
  const handleClose = () => {
    onClose()
    handleExit()
  }

  return (
    <section className="omm-delivery-modal">
      <h2>Audience Delivering...</h2>
      <div className="omm-delivery-modal__steps">
        <div>
          <Icon icon="checked" type="outline" color="#3d3d3d" height="80px" width="80px" />
          <p>Submit Audience</p>
        </div>
        <div>
          <Icon icon="angleright" type="outline" color="#3d3d3d" height="28px" width="28px" />
        </div>
        <div>
          <Icon icon="search" type="outline" color="#3d3d3d" height="80px" width="80px" />
          <p>Finding URLs</p>
        </div>
        <div>
          <Icon icon="angleright" type="outline" color="#3d3d3d" height="28px" width="28px" />
        </div>
        <div>
          <Icon icon="uploadcloud" type="outline" color="#13682B" height="80px" width="80px" />
          <p style={{ color: '#13682B', fontWeight: 600 }}>Delivering</p>
        </div>
      </div>
      <div className="mt-4 flex justify-center">
        <Button className="st-new-entity-modal__button" onClick={handleClose}>
          Got it
        </Button>
      </div>
    </section>
  )
}

DeliveryModal.propTypes = {
  onClose: PropTypes.func,
  handleExit: PropTypes.func,
}

export default DeliveryModal
